var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCompanyMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8 2H7.2C6.0799 2 5.51984 2 5.09202 2.19377C4.71569 2.36421 4.40973 2.63617 4.21799 2.97068C4 3.35097 4 3.8488 4 4.84444V18H16V4.84444C16 3.8488 16 3.35097 15.782 2.97068C15.5903 2.63617 15.2843 2.36421 14.908 2.19377C14.4802 2 13.9201 2 12.8 2Z",
    fill: "#1B92FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 18L17 18",
    stroke: "#1B92FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5H13",
    stroke: "#E9F4FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8H13",
    stroke: "#E9F4FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11H13",
    stroke: "#E9F4FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCompanyMedium);
export default __webpack_public_path__ + "static/media/ic_company_medium.4aa570decc4cd8ba76bdac1ba3f959c4.svg";
export { ForwardRef as ReactComponent };